"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _basicBanner = require("./basicBanner");

var _basicBanner2 = _interopRequireDefault(_basicBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _basicBanner2.default;